<template>
    <sui-modal
            v-model="showModalDialog"
            size="tiny"
            style="z-index: 21000;"
            :closable="false"
    >
        <sui-modal-header>Причина отклонения</sui-modal-header>
        <sui-modal-content>
            <form>
                <v-radio-group v-model="selectedRejectionReason">
                    <v-radio v-for="(rejectionReason,index) in rejectionReasons"
                             color="blue darken-2"
                             :key="index"
                             :label="rejectionReason"
                             :value="index"
                             :style="{'margin-bottom':index===rejectionReasons.length-1?'8px':'16px'}"
                    ></v-radio>
                    <div style="display: flex" class="radioWithTextField">
                        <v-radio
                                color="blue darken-2"
                                :value="-1"
                                :style="{margin:'0px'}"
                        ></v-radio>
                        <v-text-field
                                @focus="selectedRejectionReason=-1"
                                v-model="otherRejectedReason"
                                :style="{margin:'0px','padding-top':'0px'}"
                                color="blue darken-2"
                                placeholder="Другая"
                        ></v-text-field>
                    </div>
                </v-radio-group>
                <div style="display: flex;justify-content: flex-end">
                    <v-btn round color="blue darken-2" dark
                           :disabled="selectedRejectionReason===null||(selectedRejectionReason===-1&&!otherRejectedReason)"
                           @click="onConfirmButtonClick"
                    >
                        отклонить
                    </v-btn>
                    <v-btn round flat
                           @click="showModalDialog=false"
                    >
                        отмена
                    </v-btn>
                </div>
            </form>
        </sui-modal-content>
    </sui-modal>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            rejectionReasons: {
                type: Array,
                default: () => []
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectedRejectionReason: null,
                otherRejectedReason: null,
                showModalDialog: this.show
            }
        },
        computed: {},
        methods: {
            onConfirmButtonClick() {
                this.showModalDialog = false;

                let rejectionReason = this.selectedRejectionReason !== -1 ?
                    this.rejectionReasons[this.selectedRejectionReason] : this.otherRejectedReason;

                this.$emit('rejectionReasonSelected', rejectionReason);
            }
        },

        components: {},
        watch: {
            show(newVal) {
                this.showModalDialog = newVal;
                this.selectedRejectionReason = null;
                this.otherRejectedReason = null;
            },
            showModalDialog(newVal) {
                this.$emit('update:show', newVal);
            }
        }

    }
</script>

<style>
    .radioWithTextField .v-input__slot {
        margin-bottom: 0 !important;
    }
</style>
